// extracted by mini-css-extract-plugin
export default {"loaderText":"YesBankLoader_loaderText__Rld55","container":"YesBankLoader_container__8Zbhp","sheet_container_loader":"YesBankLoader_sheet_container_loader__GBmST"};